import axios from '@/http/index'

// 获取用户信息
export const getUser = (params) => {
    return axios({
        method: 'GET',
        url: '/user/curr_user',
		params
    })
}

// 用户退出接口
export const userLogout = (params) => {
    return axios({
        method: 'GET',
        url: '/login/logout',
		params
    })
}

// 用户退出接口2
export const userLogout2 = (params) => {
    return axios({
        method: 'POST',
		base: 'user',
        url: '/user/logout',
		params
    })
}
